<sb-support-account-widget sbSurface [account]="account()" />

@if (hasOnboardingChecklist()) {
  <sb-support-checklist-widget sbSurface (getStarted)="openOnboardingChecklist()" />
}

<div sbSurface class="col-span-2 flex flex-col gap-4">
  <sb-chat-widget (chatToggled)="chatToggled($event)" [hasConsent]="hasConsent" />

  @if (mode() === 'accountManager') {
    <sb-support-access-widget />
  }
</div>

@if (mode() === 'accountManager') {
  <sb-support-contact-widget
    sbSurface
    class="col-span-2"
    [supportEmail]="supportEmail()"
    [supportPhone]="supportPhone()"
  />

  <sb-remote-support-widget sbSurface class="col-span-2" />
}
